var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple360(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 182,
    viewBox: "0 0 382 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 382,
    height: 182
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 182,
    rx: 16,
    fill: "#190033"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M445.23 55.8435C494.254 55.2399 567.544 46.0928 575.188 62.917C582.969 79.8237 525.104 122.702 494.687 155.696C464.271 188.69 461.18 211.816 449.365 252.375C437.427 292.951 416.778 351.059 382.623 363.872C348.468 376.686 300.808 344.205 259.722 316.079C218.5 287.87 183.865 264.115 162.279 232.735C140.679 201.256 132.276 162.332 150.072 132.768C167.881 103.303 212.011 83.1809 249.022 69.374C286.033 55.5671 316.047 48.0592 343.618 48.2503C371.066 48.458 396.083 56.4638 445.23 55.8435Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M494.319 59.9671C533.686 66.0102 593.437 66.816 597.733 84.6433C602.13 102.571 551.072 137.521 523.095 166.327C495.118 195.132 490.122 217.794 476.234 256.672C462.245 295.549 439.364 350.744 410.588 358.902C381.811 367.06 347.14 328.183 317.265 294.542C287.289 260.801 262.11 232.398 248.222 198.154C234.333 163.809 231.835 123.823 249.321 96.7296C266.806 69.7368 304.375 55.6361 335.55 46.8736C366.724 38.111 391.603 34.6865 413.685 38.6146C435.667 42.5426 454.851 53.9239 494.319 59.9671Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M294.341 401.638C331.05 417.158 382.415 447.79 395.346 434.962C408.416 422.101 383.052 365.781 374.174 326.754C365.295 287.726 372.818 265.94 381.188 225.776C389.473 185.56 398.659 126.883 378.365 104.901C358.071 82.9195 308.296 97.6341 265.333 110.432C222.233 123.263 185.998 134.092 156.352 155.779C126.654 177.552 103.735 210.065 104.559 242.146C105.434 274.141 130.136 305.757 152.161 329.507C174.186 353.256 193.619 369.191 214.489 377.441C235.274 385.639 257.548 386.066 294.341 401.638Z",
    fill: "#B2E7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple360);
export default __webpack_public_path__ + "static/media/Purple360.4ff5aa5c0444d705195816de3868679d.svg";
export { ForwardRef as ReactComponent };